import { IGetEmpreendimentoBlocoDropDownUseCase } from "../../../presentation/useCases/read/get_empreendimento_bloco_drop_down_use_case";
import { EmpreendimentoBlocoDropDown } from "../../models/empreendimento_bloco_dropdown";
import { IIncorporacaoRepository } from "../../repositories/incorporacao_repositories";

/**
 * getEmpreendimentoBlocoDropDownUseCase
 */

export class GetEmpreendimentoBlocoDropDownUseCase implements IGetEmpreendimentoBlocoDropDownUseCase {
  constructor(private readonly repository: IIncorporacaoRepository) { }

  async getEmpreendimentoBlocoDropdown(idEmpreendimento: number): Promise<EmpreendimentoBlocoDropDown[]> {
    const response = await this.repository.getEmpreendimentoBlocoDropDown(idEmpreendimento)
    return response

  };
}
